import DataFetch from '../../Utility/data-fetch';

const preHighlightClass = 'bg-yellow-300';
const highlightClass = 'bg-green-100';
const selectionClass = 'selected';

const call = (baseUrl) => {
    return {
        currentPassage: {
            translationCode: '',
            bookCode: '',
            chapterId: 0,
            verseId: 0,
        },
        baseUrl: `${baseUrl}`,
        allHighlights: [],
        highlights: [],
        showError: false,
        allLoading: false,
        loading: false,
        selectedVerses: [],
        page: 1,
        itemsPerPage: 10,

        async turnPage(turnFunc) {
            const newPage = turnFunc(this.page);
            if (newPage !== this.page) {
                this.page = newPage;
                await this.getAllHighlights(this.page, this.itemsPerPage);
            }
        },
        async nextPage() {
            await this.turnPage(page => (this.allHighlights && this.allHighlights.length === this.itemsPerPage) ? page + 1 : page);
        },
        async prevPage() {
            await this.turnPage(page => (page > 1) ? page - 1 : page);
        },

        assignPassage(translationCode, bookCode, chapterId) {
            this.currentPassage = {
                translationCode: translationCode,
                bookCode: bookCode,
                chapterId: chapterId,
            };
        },

        async getAllHighlights() {
            try {
                this.allLoading = true;
                this.highlights = [];
                const response = await DataFetch.get(this.baseUrl, {
                    params: {
                        page: this.page,
                        itemsPerPage: this.itemsPerPage,
                    },
                });
                this.allHighlights = response.data;
            } catch (error) {
                console.error(error); // You may handle error in a way that fits your application.
            } finally {
                this.allLoading = false;
            }
        },

        async getHighlights() {
            this.loading = true;
            this.highlights = [];

            try {
                const response = await DataFetch.get(this.baseUrl, {
                    params: {
                        bookCode: this.currentPassage.bookCode,
                        chapterId: this.currentPassage.chapterId,
                    },
                });

                this.highlights = response.data;
                this.highlightExisting();
            } catch (error) {
                // you may handle or log error here if necessary
                // console.error(error);
            } finally {
                this.loading = false;
            }
        },

        highlightExisting() {
            const elems = document.getElementsByClassName('bible-selectable-verse');

            this.clearAllClasses(elems);
            this.fillHighlights();
        },
        clearAllClasses(elems) {
            Array.from(elems).forEach(elem => {
                elem.classList.remove(preHighlightClass);
                elem.classList.remove(highlightClass);
                elem.classList.remove(selectionClass);
            });
        },
        fillHighlights() {
            this.highlights.forEach(highlight => {
                const elem = document.querySelector(`.verse-${highlight.verseId}`);
                elem.classList.add(preHighlightClass);
            });
        },

        async addHighlights() {
            const verseElems = Array.from(document.getElementsByClassName(`${selectionClass}`));
            this.selectedVerses = verseElems.map((verseElement) => this.createVerseObject(verseElement));

            try {
                await DataFetch.post(this.baseUrl, this.selectedVerses);
                this.page = 1;
                await this.getAllHighlights();
                await this.getHighlights();
                this.showError = false;
            } catch (error) {
                this.showError = true;
            }
        },

        createVerseObject(verseElement) {
            const {translationCode, bookCode, chapterId} = this.currentPassage;
            return {
                translationCode,
                bookCode,
                chapterId,
                verseId: verseElement.dataset.verseId,
            };
        },

        async deleteHighlight(translationCode, bookCode, chapterId, verseId) {
            const userResponse = window.confirm('Are you sure you wish to delete this highlight?');
            if (!userResponse) {
                return;
            }
            const highlightDetails = {
                translationCode: translationCode,
                bookCode: bookCode,
                chapterId: chapterId,
                verseId: verseId,
            };
            return await DataFetch.remove(`${this.baseUrl}`, {data: highlightDetails})
                .then(async () => {
                    await this.getAllHighlights();
                    await this.getHighlights();
                });
        },
    };
};

export default call;